import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/calendars/cal_2021_mar.png'
import _imports_1 from '../../assets/images/jam_4.jpg'
import _imports_2 from '../../assets/images/weekly_jams/weekly_4.jpg'
import _imports_3 from '../../assets/images/social_10.jpg'


const _withScopeId = n => (_pushScopeId("data-v-7746e02e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "links_wrapper" }
const _hoisted_3 = { class: "link_container" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"divider calendar\" data-v-7746e02e><div class=\"divider_text\" data-v-7746e02e>calendar</div></div><div class=\"cal_container\" data-v-7746e02e><img src=\"" + _imports_0 + "\" data-v-7746e02e></div><div class=\"divider reg_events\" data-v-7746e02e><div class=\"divider_text\" data-v-7746e02e>regular events</div></div><div class=\"reg_events_container\" data-v-7746e02e><div class=\"events\" data-v-7746e02e><div class=\"event evnt1\" data-v-7746e02e><div class=\"e_title\" data-v-7746e02e>casual jams</div><img src=\"" + _imports_1 + "\" data-v-7746e02e><div class=\"e_desc\" data-v-7746e02e> Meant for musicians to collaborate with each other and listeners to enjoy; a weekly no-pressure environment where you can mingle with your fellow members, practice with other musicians and/or lounge for a couple hours. </div></div><div class=\"event evnt2\" data-v-7746e02e><div class=\"e_title\" data-v-7746e02e>genre nights</div><img src=\"" + _imports_2 + "\" data-v-7746e02e><div class=\"e_desc\" data-v-7746e02e> Know how to play an instrument but not in jazz? We got you. Genre nights focus on specific genres of jazz and the techniques associated. With the guidance of our veteran musicians you’re sure to get it down. </div></div><div class=\"event evnt3\" data-v-7746e02e><div class=\"e_title\" data-v-7746e02e>concerts</div><img src=\"" + _imports_3 + "\" data-v-7746e02e><div class=\"e_desc\" data-v-7746e02e> At the end of every term, we like to feature the growth and talents of our musicians in a more formal setting. With snacks and social intermissions, it’s a great place to enjoy all the best things about Jazz Club: our engaged listeners and talented musicians. </div></div></div></div><div class=\"divider history\" data-v-7746e02e><div class=\"divider_text\" data-v-7746e02e>our history</div></div>", 5)
const _hoisted_9 = { class: "timeline_wrapper" }
const _hoisted_10 = { class: "timeline" }
const _hoisted_11 = { class: "timeline_year" }
const _hoisted_12 = { class: "timeline_month" }
const _hoisted_13 = { class: "timeline_date" }
const _hoisted_14 = { class: "date" }
const _hoisted_15 = { class: "timeline_box" }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "right" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "desc" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "link",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.moveTo('.calendar')))
        }, "calendar"),
        _createElementVNode("div", {
          class: "link",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.moveTo('.reg_events')))
        }, "regular events"),
        _createElementVNode("div", {
          class: "link",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.moveTo('.history')))
        }, "timeline")
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allEvents, (i) => {
          return (_openBlock(), _createElementBlock("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.eventYear, (j) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["timeline_year_w", j.sep])
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(j.year), 1)
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(j.events, (event) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["timeline_group", event.first])
                    }, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(event.month), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(event.date), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("img", {
                            src: event.image
                          }, null, 8, _hoisted_17)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(event.title), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(event.desc), 1)
                        ])
                      ])
                    ], 2)
                  ]))
                }), 256))
              ]))
            }), 256))
          ]))
        }), 256))
      ])
    ])
  ]))
}